import React, {useMemo, useState} from 'react';
import {Dialog, Button, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {ValidatorForm} from 'react-material-ui-form-validator';

import Tx from '../Tx';
import Table from '../../components/Table';
import {api} from '../../maps/data.js';
import {excelRenderer} from '../../domain/excelParser.js';

// Utility function to break an array into chunks
const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}

const ImportExcelDialog = ({open, onClose, categories, refresh}) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);

    const categoriesMap = useMemo(() => {
        return categories.reduce((acc, item) => ({...acc, [item.name]: item._id}), {});
    }, [categories]);

    const handleSave = async () => {
        const chunkSize = 30;
        const arrayOfChunks = chunkArray(data, chunkSize);

        try {
            const arrPromises = arrayOfChunks.map(async (arrData) => {
                return await api({
                    type: 'addProductsChunk',
                    data: arrData
                });
            });
            await Promise.all(arrPromises);
            refresh();
            onClose();
        } catch (err) {
            console.log({err});
        }
    }

    const isExcelRowEmpty = (row) => {
        return row.length === 0;
    }

    const fileHandler = (event) => {
        const fileObj = event.target.files[0];

        excelRenderer(fileObj, (err, response) => {
            if (err) console.log(err);
            else {
                const rows = response.rows.slice(1);
                // const {rows} = response;

                // Removing empty lines and column titles
                const filteredProducts = rows.filter((item) => {
                    console.log('item length', item.length);
                    return item.length > 0;
                    // return !isExcelRowEmpty(item);
                });

                // Validation of Excel rows
                let errors = [];
                for (const index in filteredProducts) {
                    const [barcode, name, categoryName] = filteredProducts[index];
                    const categoryId = categoriesMap[categoryName.trim()];
                    try {
                        if (!name) throw {msg: `Bad file, missing name at row: ${index}`};
                        if (!barcode) throw {msg: `Bad file, missing barcode at row: ${index}`};
                        if (!categoryId) throw {msg: `Bad file, category ${categoryName} was not found.`};
                    } catch (err) {
                        errors.push(err.msg);
                        setError(true);
                        alert(err.msg);
                        break;
                    }
                }

                /*if (errors.length) {
                    setError(true);
                    alert(errors);
                }*/

                const data = filteredProducts.reduce((acc, item) => {
                    const [barcode, name, category, avgWeight, price, producedBy, amountOfElements, supplier, hdType] = item;
                    const categoryId = categoriesMap[category.trim()];
                    return [
                        ...acc, {
                            type: hdType || 'SHELF',
                            name,
                            barcode,
                            categoryId,
                            category,
                            avgWeight,
                            price,
                            producedBy,
                            amountOfElements,
                            amountOfElementsText: parseProductElementsAmount(amountOfElements),
                            supplier
                        }];
                }, []);

                setData(data);
            }
        });
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="import-excel-dialog-title"
            aria-describedby="import-excel-dialog-description"
            maxWidth={data.length > 0 ? 'lg' : 'md'}
            fullWidth={true}
        >
            <ValidatorForm
                onSubmit={handleSave}
                onError={errors => console.log(errors)}>

                {/* Title */}
                <DialogTitle id="import-excel-dialog-title">
                    <Tx>g.importFromExcel</Tx>
                </DialogTitle>

                {/* Table Content */}
                <DialogContent style={{paddingTop: 5}}>
                    <input type="file" onChange={fileHandler} style={{padding: 10}}/>
                    <Table
                        data={data}
                        headers={[
                            {label: <Tx>product.form.name</Tx>, field: 'name'},
                            {label: <Tx>product.form.barcode</Tx>, field: 'barcode'},
                            {label: <Tx>product.category</Tx>, field: 'category'},
                            {label: <Tx>product.form.weight</Tx>, field: 'avgWeight'},
                            {label: <Tx>product.form.price</Tx>, field: 'price'},
                            {label: <Tx>product.unitPackage</Tx>, field: 'amountOfElementsText'},
                            {label: <Tx>product.supplier</Tx>, field: 'supplier'},
                            {label: <Tx>product.producer</Tx>, field: 'producedBy'},
                            {label: <Tx>product.hdType</Tx>, field: 'type'},
                        ]}
                    />
                </DialogContent>

                {/* Bottom Action */}
                <DialogActions>
                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button disabled={!data.length || error} type="submit"><Tx>g.save</Tx></Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>
    );
}

export default ImportExcelDialog;

export const parseProductElementsAmount = (amount) => {
    if (amount > 1) return <><Tx>product.packageOf</Tx>&nbsp;<span>{amount}</span></>
    return <Tx>product.unit</Tx>
}